import React, { useState, useMemo, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import withWidth from "@material-ui/core/withWidth";
import PersonIcon from "@material-ui/icons/Person";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import { NavLink, withRouter } from "react-router-dom";

import Logo from "../../../assets/images/logo-cargill.png";
import Confirm from "../../Confirm";
import useStyles from "./styles";
import { connect } from "react-redux";
import ProfileLabel from "../ProfileLabel";
import { logOff } from "../../../api/api-client";

function DrawerContent({ user, menus, handleDrawerToggle, setNoCache, profileLink, selectedMenu, setSelectedMenu }) {
  const classes = useStyles();
  const [isModalOpen, setModalOpen] = useState(false);
  const [inHover, setHover] = useState(false);
  const onLogoff = () => {
    setModalOpen(true);
  };
  function handleClose(option) {
    setModalOpen(false);
    if (option) {
      logOff();
    }
  }
  useEffect(()=>{
    setSelectedMenu()
  },[setSelectedMenu])

  function hdlSetSelectedIndex(index) {
    setSelectedMenu(index);
    handleDrawerToggle();
    setNoCache();
  }

  function ListItemLink(props) {
    const linkProps = props.href
      ? { href: props.href }
      : { to: props.to, exact: props.exact };



    return (
      <ListItem
        onMouseEnter={() => setHover(props.index)}
        onMouseLeave={() => setHover(false)}
        className={
         ( selectedMenu===props.index||inHover=== props.index )
            ? classes.listStyleSelected
            : classes.listStyle
        }
        p={0}
        onClick={props.onClick}
        button
        component={props.href ? "a" : NavLink}
        {...linkProps}
      >
        <ListItemText className={classes.linkStyle}>
          {props.children}
        </ListItemText>
      </ListItem>
    );
  }

  const getSubRoutesFromMenu = (menuOptions) => {
    return menuOptions.reduce((prev, curr) => {
      if (curr.subRoutes && curr.subRoutes.length) {
        return [...prev, ...curr.subRoutes];
      }
      return prev;
    }, []);
  };

  const subRoutes = useMemo(() => getSubRoutesFromMenu(menus), [menus]);

  const ocSearchAction = subRoutes.find(action => action.title === "Pesquisar Carregamento");

  const uriNewScheduling = window.location.host.includes('localhost') ? 'http://localhost:3001/peach/scheduling' : '/peach/scheduling'
  const uriOperationLineScreen = window.location.host.includes('localhost') ? 'http://localhost:3001/operation-lines' : '/peach/operation-lines'

  const uriNewCTScreen = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/cargill-transports/loading-orders' : '/peach/new/tdms/cargill-transports/loading-orders'
  const uriNewFarmerScreen = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/farm/loading-orders' : '/peach/new/tdms/farm/loading-orders'
  const uriNewTransporterScreen = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/transporter/loading-orders' : '/peach/new/tdms/transporter/loading-orders'
  const uriNewWarehouseScreen = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/warehouse/loading-orders' : '/peach/new/tdms/warehouse/loading-orders'
  const uriNewBackofficeScreen = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/backoffice/loading-orders' : '/peach/new/tdms/backoffice/loading-orders'

  const uriTransportInvoiceBackoffice = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/freight-invoice/backoffice' : '/peach/new/tdms/freight-invoice/backoffice'
  const uriTransportInvoiceTransporter = window.location.host.includes('localhost') ? 'http://localhost:3002/new/tdms/freight-invoice/transportista' : '/peach/new/tdms/freight-invoice/transportista'

  return (
    <div className={classes.drawerContent}>
      <Confirm
        isOpen={isModalOpen}
        title="Deseja realmente sair?"
        okText="Sim"
        cancelText="Não"
        data-cy="leave-modal"
        id="leave-modal"
        handleClose={handleClose}
      />
      <Box>
        <Hidden smDown implementation="css">
          <Box mt={4} mb={5} className={classes.logoArea}>
            <img src={Logo} className={classes.logo} alt="Cargill logo" />
          </Box>
        </Hidden>
        <Hidden mdUp implementation="css">
          <Box mt={1} mb={3} className={classes.navMobileArea}>
            <div>
              <IconButton
                onClick={handleDrawerToggle}
                aria-label="upload picture"
                component="span"
                data-cy="profile-back-btn"
                id="profile-back-btn"
              >
                <ArrowBackIcon className={classes.userIcon} data-cy="menu-arrow-back-icon" id="menu-arrow-back-icon"/>
              </IconButton>
            </div>
            <div>
              <IconButton
                onClick={handleDrawerToggle}
                aria-label="upload picture"
                component="span"
                data-cy="close-btn"
                id="profile-close-btn"
              >
                <CloseIcon className={classes.userIcon} />
              </IconButton>
            </div>
          </Box>
        </Hidden>
        <Box pl={2} pr={2}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Typography className={classes.userName} variant="subtitle1">
                {user.name}
              </Typography>
              <ProfileLabel classStyle={classes.userRole} />
            </Grid>
            <Hidden smDown>
              <Grid item>
                <PersonIcon className={classes.userIcon} />
              </Grid>
            </Hidden>
          </Grid>
        </Box>
        <Box pt={6}>
          <List component="nav" aria-label="main mailbox folders">
            <ListItem
              onMouseEnter={() => setHover("account")}
              onMouseLeave={() => setHover(false)}
              p={0}
              button
              href={profileLink}
              key="my-account"
              className={
                (selectedMenu=== "account"||inHover==="account")
                  ? classes.listStyleSelected
                  : classes.listStyle
              }
              onClick={() => hdlSetSelectedIndex("account")}
              component="a"
            >
              <ListItemText className={classes.linkStyle} id="menu-item-my-account" data-cy="menu-item-my-account">
                Minha conta
              </ListItemText>
            </ListItem>
            <Hidden smDown>
              {menus &&
                menus.map((s, index) => {
                  if (s.route.includes('/peach/scheduling')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewScheduling}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/cargill-transports/loading-orders')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewCTScreen}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/farm/loading-orders')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewFarmerScreen}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/transporter/loading-orders')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewTransporterScreen}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/warehouse/loading-orders')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewWarehouseScreen}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/backoffice/loading-orders')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriNewBackofficeScreen}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/freight-invoice/backoffice')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriTransportInvoiceBackoffice}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }
                  if (s.route.includes('/peach/new/tdms/freight-invoice/transportista')) {
                      return (
                        <ListItemLink
                          key={index}
                          index={index}
                          onClick={() => hdlSetSelectedIndex(index)}
                          href={uriTransportInvoiceTransporter}
                        >
                          <span
                            id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                            data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                          >
                            {s.title}
                          </span>
                        </ListItemLink>
                      )
                    }

                  return (
                  <ListItemLink
                    key={index}
                    exact={true}
                    index={index}
                    onClick={() => hdlSetSelectedIndex(index)}
                    href={s.href}
                    to={
                      s.subRoutes && s.subRoutes.length
                        ? s.subRoutes[0].route
                        : s.route
                    }

                  >
                    <span
                      id={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                      data-cy={`menu-item-${s.title.toLowerCase().replace(' ', '-')}`}
                    >
                      {s.title}
                    </span>
                  </ListItemLink>
                )})}
                {["backoffice", "support"].includes(user.mainGroup) && (
                  <>
                  <ListItem
                        p={0}
                        button
                        href={`/trocar-documentos/backoffice-homepage`}
                        key="yard-management-tyeste"
                        component="a"
                        className={
                           (selectedMenu === "yard-management"||
                            inHover==="yard-management")
                            ? classes.listStyleSelected
                            : classes.listStyle
                        }
                        onMouseEnter={() => setHover("yard")}
                        onMouseLeave={() => setHover(false)}
                        id="menu-item-yard-management"
                        data-cy="menu-item-yard-management"
                      >
                        <ListItemText className={classes.linkStyle}>
                          Backoffice Home Page
                        </ListItemText>
                    </ListItem>
                    <ListItem
                        p={0}
                        button
                        target="_blank"
                        // href={`${window.location.origin}/peach/operation-lines`}
                        href={uriOperationLineScreen}
                        key="yard-management"
                        component="a"
                        className={
                           (selectedMenu === "yard-management"||
                            inHover==="yard-management")
                            ? classes.listStyleSelected
                            : classes.listStyle
                        }
                        onMouseEnter={() => setHover("yard")}
                        onMouseLeave={() => setHover(false)}
                        id="menu-item-yard-management"
                        data-cy="menu-item-yard-management"
                      >
                        <ListItemText className={classes.linkStyle}>
                          Gestão de Pátio
                        </ListItemText>
                    </ListItem>
                    <ListItem
                        p={0}
                        button
                        target="_blank"
                        href="https://app.powerbi.com/reportEmbed?reportId=e6345390-e57d-462a-ace4-7b1c6978ef6e&autoAuth=true&ctid=57368c21-b8cf-42cf-bd0b-43ecd4bc62ae&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                        key="report-docs"
                        component="a"
                        className={
                           (selectedMenu === "report-docs"||
                            inHover==="report-docs")
                            ? classes.listStyleSelected
                            : classes.listStyle
                        }
                        onMouseEnter={() => setHover("report-docs")}
                        onMouseLeave={() => setHover(false)}
                        id="menu-item-document-exchange-report"
                        data-cy="menu-item-document-exchange-report"
                      >
                        <ListItemText className={classes.linkStyle}>
                          Relatorios - Troca de documentos
                      </ListItemText>
                    </ListItem>
                    {/* <ListItem
                        p={0}
                        button
                        target="_blank"
                        href="/agendamento/configuracoes"
                        key="agendamento-config"
                        component="a"
                        className={
                           (selectedMenu === "agendamento-config"||
                            inHover==="agendamento-config")
                            ? classes.listStyleSelected
                            : classes.listStyle
                        }
                        onMouseEnter={() => setHover("agendamento-config")}
                        onMouseLeave={() => setHover(false)}
                      >
                        <ListItemText className={classes.linkStyle}>
                          Agendamento Configurações
                      </ListItemText>
                    </ListItem>*/}
                    <ListItem
                        p={0}
                        button
                        target="_blank"
                        href="https://app.powerbi.com/reportEmbed?reportId=8b74c537-3d1d-4257-8162-a7be6d133628&autoAuth=true&ctid=57368c21-b8cf-42cf-bd0b-43ecd4bc62ae&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                        key="report-trucks"
                        component="a"
                          className={
                          (selectedMenu === "report-trucks"||inHover==="report-trucks")
                            ? classes.listStyleSelected
                            : classes.listStyle
                        }
                        onMouseEnter={() => setHover("report-trucks")}
                        onMouseLeave={() => setHover(false)}
                        id="menu-item-truck-position-report"
                        data-cy="menu-item-truck-position-report"
                      >
                        <ListItemText className={classes.linkStyle}>
                          Relatorios - Posição de Caminhões
                      </ListItemText>
                    </ListItem>
                  </>
                )}
            </Hidden>
            <Hidden smUp>
              {ocSearchAction && (
                <ListItem
                  onMouseEnter={() => setHover(ocSearchAction.title)}
                  onMouseLeave={() => setHover(false)}
                  p={0}
                  button
                  key="search-loading-order"
                  onClick={() => {hdlSetSelectedIndex(ocSearchAction.title); handleDrawerToggle();}}
                  href={ocSearchAction.href}
                  exact={true}
                  to={ocSearchAction.route}
                  className={
                   ( selectedMenu === ocSearchAction.title||inHover===ocSearchAction.title  )
                      ? classes.listStyleSelected
                      : classes.listStyle
                  }
                  component={NavLink}
                  id="menu-item-oc-search-action"
                  data-cy="menu-item-oc-search-action"
                >
                  <Box className={classes.menuMobileTitle}>
                    <ListItemText className={classes.linkStyle}>
                        {ocSearchAction.title}
                    </ListItemText>
                    <SearchIcon className={classes.searchIcon}/>
                  </Box>
                </ListItem>
              )}
              {subRoutes &&
                subRoutes.filter(route => route.title !== "Pesquisar Carregamento").map((s, index) => {
                  return (
                    <ListItemLink
                      key={index}
                      onClick={() => {hdlSetSelectedIndex(index); handleDrawerToggle();}}
                      index={index}
                      exact={true}
                      href={s.href}
                      to={s.route}
                      id="menu-item-not-searching-load"
                      data-cy="menu-item-not-searching-load"
                    >
                      {s.title}
                    </ListItemLink>
                  );
                })}
            </Hidden>
          </List>
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={onLogoff}
        data-cy="profile-out-button"
        id="profile-out-button"
        classes={{
          root: classes.exitButton,
          label: classes.exitButtonLabel,
        }}
        endIcon={<ExitToAppIcon />}
      >
        Sair
      </Button>
    </div>
  );
}

DrawerContent.propTypes = {
  user: PropTypes.object.isRequired,
  handleDrawerToggle: PropTypes.func,
};

const mapState = ({ auth: { user, envSettings }, navigation }) => {
  let data = {
    profileLink: `${envSettings.oktaOrganizationURI}/enduser/settings`,
    selectedMenu: navigation.selectedMenu
  };
  if (user.mainGroup === "farmer") {
    data.profileLink = `${envSettings.gpsURI}/cascsa/pt/pages/dashboard`;
  }

  return data;
};



const mapDispatch = (dispatch) => ({
  setNoCache: (payload = null) => dispatch.navigation.setNoCache(payload),
  setSelectedMenu: (payload) => dispatch.navigation.getSelectedMenuItemAsync(payload)
});

export default withWidth()(withRouter(connect(mapState, mapDispatch)(DrawerContent)));
